import { render, staticRenderFns } from "./AfterSalePickEdit.vue?vue&type=template&id=6084720c"
import script from "./AfterSalePickEdit.vue?vue&type=script&lang=js"
export * from "./AfterSalePickEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports